export const errors = {
  'no-medical-consultation-found': 'No hay resultados que coincidan para auditar',
};
